import { PayloadAction } from '@reduxjs/toolkit'
import { TProductFilters } from '../../../models'

const setSearch = (
  state: TProductFilters[],
  action: PayloadAction<{
    id: number
    search?: string
  }>
) => {
  const selectedFilters = state.find((item) => item.id === action.payload.id)

  if (!selectedFilters) {
    const newState = { id: action.payload.id, filters: {} }
    state.push(newState)
  } else {
    // @ts-expect-error: fix in PORT-2536
    selectedFilters.filters.search = action.payload.search || undefined
  }
}

export default setSearch
